import { PusherService } from './../../../ng2/shared/services/pusher/pusher-service';
import { CurrentSchoolYear } from 'Src/ng2/shared/constants/current-school-year.constant';
import { ISummerSchool } from './../../../ng2/shared/typings/interfaces/school.interface';
import { GOOGLE_CLASSROOM_MIDLEVEL } from './../../../ng2/shared/constants/google-classroom.constant';
import { REMOTE_INTERACTION_MIDLEVEL } from './../../../ng2/shared/constants/remote-interaction.constant';
import { Store } from '@ngrx/store';
import * as angular from 'angular';
import { IStateService } from 'angular-ui-router';
import { each, filter, groupBy, includes } from 'lodash';
import { of, Subject } from 'rxjs';
import { map, take, takeUntil, tap } from 'rxjs/operators';
import {
  GOOGLE_SHEETS_OPTIONS,
  SHEET_TYPE_HUMAN_MAP,
  SHEET_TYPE_TO_ROUTE,
} from 'Src/ng2/school/school-tools/other-tools/other-tools.constant';
import { Toggles } from 'Src/ng2/shared/constants/toggles.constant';
import { ITool } from 'Src/ng2/shared/typings/interfaces/tool.interface';
import { POSTSECONDARY_MADLIB_CONFIG } from '../../../ng2/school/lists/postsecondary-list/postsecondary-list-mad-lib/postsecondary-mad-lib.constant';
import { Auth } from '../../../ng2/shared/auth/auth.service';
import { USER_ROLE_PERMISSIONS_FOR_STATES } from '../../../ng2/shared/constants/user-role-permissions-for-states.constant';
import { ImUser } from '../../../ng2/shared/services/im-models/im-user';
import { ImSchool } from '../../../ng2/shared/services/im-models/im-school';
import { ToggleService } from '../../../ng2/shared/services/toggle/toggle.service';
import { ISchool } from '../../../ng2/shared/typings/interfaces/school.interface';
import { IUser } from '../../../ng2/shared/typings/interfaces/user.interface';
import {
  getMyStudentsList,
  getMyStudentsLoadedStatus,
  getSchoolAssessmentsEntitiesList,
  getSchoolAssessmentsLoadedStatus,
  getStudentAssessmentsEntitiesList,
  getStudentAssessmentsLoadedStatus,
  getUsersLoadedStatus,
  LoadMyStudents,
  LoadSchoolAssessments,
  LoadStudentAssessments,
  LoadTogglesSuccess,
  LoadUsersSuccess,
  ToggleBatchActions,
  UpdateSelectedStudentIds,
} from '../../../ng2/store';
import { LoadPostsecondaryStudents } from '../../../ng2/store/actions/students-actions/students-postsecondary-actions';
import { getBatchActionsMode } from '../../../ng2/store/selectors/batch-actions-selectors';
import { SpinnerModal } from '../../shared/modals/status-spinner/status-spinner.service';
import { ACADEMIC_MADLIB_CONFIG } from './../../../ng2/school/lists/academic-list/academic-mad-lib/academic-mad-lib.constant';
import { ATTENDANCE_MADLIB_CONFIG } from './../../../ng2/school/lists/attendance-list/attendance-mad-lib/attendance-mad-lib.constant';
import { MY_STUDENTS_MADLIB_CONFIG } from './../../../ng2/school/lists/my-students-list/my-students-mad-lib/my-students-mad-lib.constant';
import { NYCT_DASH_MIDLEVEL } from './../../../ng2/shared/constants/nyct-dash.constant';
import { PrevStateService } from './../../../ng2/shared/services/prev-state/prev-state.service';
import { LoadDashboardStudents, LoadDashboardStudentSupports } from './../../../ng2/store/actions/dashboard-actions';
import { InitializePusher } from './../../../ng2/store/actions/pusher-actions';
import { LoadSchoolSuccess } from './../../../ng2/store/actions/school-actions';
import { LoadAcademicStudents, LoadAttendanceStudents } from './../../../ng2/store/actions/students-actions';
import {
  getDashboardMadLibState,
  getDashboardStudentsList,
  getDashboardStudentsLoadedStatus,
  getDashboardStudentSupports,
  getLoadedDashboardStudentSupportsStatus,
} from './../../../ng2/store/selectors/dashboard-selectors';
import {
  getAcademicStudentsList,
  getAcademicStudentsLoadedStatus,
  getAttendanceStudentsList,
  getAttendanceStudentsLoadedStatus,
  getPostsecondaryStudentsList,
  getPostsecondaryStudentsLoadedStatus,
} from './../../../ng2/store/selectors/students-selectors';
import { SchoolToolbarService } from './../../layout/toolbars/school-toolbar/school-toolbar.service';
import { SdcActionsService } from './../../sdc/flux/sdc-actions.service';
import { SYNC_ENABLED_DOMAINS } from 'Src/ng2/school/school-tools/school-tools-list/sync.constant';
import { DEPRECATED_GRAPHS } from 'Src/ng2/shared/constants/dashboard-graphs.constant';

const getDashboardToggle = (focusName: string) => {
  let toggle: string;

  const isNYCTFocus = NYCT_DASH_MIDLEVEL[focusName];
  const isRemoteInteractionFocus = REMOTE_INTERACTION_MIDLEVEL[focusName];
  const isGoogleClassroomFocus = GOOGLE_CLASSROOM_MIDLEVEL[focusName];

  if (isNYCTFocus) {
    toggle = Toggles.TOGGLE_NYCT_MVP;
  } else if (isRemoteInteractionFocus) {
    toggle = Toggles.TOGGLE_REMOTE_INTERACTION;
  } else if (isGoogleClassroomFocus) {
    toggle = Toggles.TOGGLE_GOOGLE_CLASSROOM;
  }
  return toggle;
};

/* istanbul ignore next */
angular.module('nv.routes.main').config(function($stateProvider) {
  function resetStoredListState(Store) {
    Store.dispatch(new ToggleBatchActions(false));
    Store.dispatch(new UpdateSelectedStudentIds([]));
  }

  $stateProvider
    .state('main.school', {
      abstract: true,
      url: '/school/:schoolId',
      template: `
                 <div ui-view>
                 `,
      resolve: {
        currentSchool: [
          '$stateParams',
          'School',
          'SdcStateService',
          'sdcActions',
          'UtilitiesService',
          'EventBus',
          function($stateParams, School, SdcStateService, sdcActions, UtilitiesService, EventBus) {
            let currentSchool = new School({ _id: $stateParams.schoolId });

            return new Promise((resolve, reject) => {
              currentSchool
                .$get()
                .then(function(currSchl) {
                  SdcStateService.init(currSchl);
                  sdcActions.initializeWithSchool(UtilitiesService.copyPOJO(currSchl));
                  const action = new LoadSchoolSuccess(currSchl);
                  EventBus.emitAction(action);
                  resolve(currSchl);
                })
                .catch(reject);
            });
          },
        ],
        toggles: [
          'ToggleService',
          'Store',
          'currentSchool',
          (toggleService: ToggleService, store: Store<any>, currentSchool) => {
            // Pass options required to compute toggles in backend (Dvn)
            const toggleOption = { currentSchoolId: currentSchool._id };
            return toggleService
              .getAllComputedToggles(toggleOption)
              .toPromise()
              .then(toggles => {
                const toggleAction = new LoadTogglesSuccess(toggles);
                store.dispatch(toggleAction);

                return toggles;
              })
              .catch(err => {
                return false;
              });
          },
        ],
        channel: [
          'PusherService',
          'currentSchool',
          'EventBus',
          'Auth',
          'Rollbar',
          function(PusherService: PusherService, currentSchool, EventBus, Auth: Auth, Rollbar) {
            // ensure that we always have the latest token for pusher when switching schools
            // this is to address: https://newvisions.atlassian.net/browse/PI-1012 (Carlos)
            try {
              const idToken = Auth.getIdToken();
              PusherService.pusher.config.auth.headers.Authorization = idToken;
            } catch (err) {
              Rollbar.debug('PusherService Authorization Header: ', err);
            }

            // This pusher-channel needs to be shared between the frameworks while in a hybrid state
            // Having the same channel/id allows us to block messages to the event initiator(JJ)
            // Update - we want to unsubscribe from any school that is not the current school (JE)
            const currentChannels = PusherService.pusher.allChannels();
            const pusherChannelName = PusherService.getChannelName(currentSchool._id);
            each(currentChannels, channel => {
              if (channel.name !== pusherChannelName) PusherService.pusher.unsubscribe(channel.name);
            });

            const channel = PusherService.pusher.channels[pusherChannelName]
              ? PusherService.pusher.channels[pusherChannelName]
              : PusherService.pusher.subscribe(pusherChannelName);

            const action = new InitializePusher(channel);
            EventBus.emitAction(action);
            return channel;
          },
        ],
        // This shows a spinner when transitioning to states that load slowly
        spinnerTransitionDeregistration: [
          '$rootScope',
          'SpinnerModal',
          ($rootScope, SpinnerModal) => {
            SpinnerModal.activateSpinner('Loading...'); // Also show spinner on initial entry to this state
            return $rootScope.$on('$routeChangeStart', () => {
              SpinnerModal.activateSpinner('Loading...');
            });
          },
        ],
        allSchoolUsers: [
          'User',
          'currentSchool',
          'sdcActions',
          'Store',
          (User, currentSchool, sdcActions: SdcActionsService, store: Store<any>) => {
            const schoolId = currentSchool._id;
            return User.getAllSchoolUsers(schoolId).then(users => {
              const usersForSdcStore = User.getMinisForSdcStore(users);
              const destroy$: Subject<boolean> = new Subject<boolean>();

              store
                .select(getUsersLoadedStatus)
                .pipe(takeUntil(destroy$))
                .subscribe(loaded => {
                  if (!loaded) {
                    // setting school users on v2 and v3 stores
                    return [
                      sdcActions.setAllSchoolUsers(usersForSdcStore),
                      store.dispatch(new LoadUsersSuccess(users)),
                    ];
                  } else {
                    destroy$.next(true);
                    destroy$.unsubscribe();
                  }
                });
            });
          },
        ],
      },
      controller: [
        '$rootScope',
        'currentSchool',
        'SchoolToolbarService',
        '$location',
        'PrevStateService',
        '$state',
        'Store',
        function(
          $rootScope,
          currentSchool,
          SchoolToolbarService: SchoolToolbarService,
          $location,
          ssvExitState: PrevStateService,
          $state: IStateService,
        ) {
          $rootScope.breadcrumb = $rootScope.breadcrumb || {};
          $rootScope.breadcrumb.currentSchoolNickName = currentSchool.nickName;

          this.currentState = SchoolToolbarService.getCurrentState();

          $rootScope.$on('$stateChangeStart', (event, toState, toParams, fromState) => {
            // TODO: Remove ssvExitState and use `config.previousStates` in store for single student view
            const url: string = $location.url();
            const urlIsValid = ssvExitState.isUrlValid(url);

            // TODO: Remove ssvExitState and use `config.previousStates` in store for single student view
            const opts = ssvExitState.getCurrentStateGoOpts($state);

            if (urlIsValid) {
              this.ssvExitState = opts;
            }
          });

          // WARNING:
          // this.currentState = SchoolToolbarService.getCurrentState() must be set in stateChangeSuccess in order
          /// for toolbar state to be represented correctly in each route/view.
          $rootScope.$on('$stateChangeSuccess', (event, toState, toParams, fromState) => {
            this.currentState = SchoolToolbarService.getCurrentState();
          });
        },
      ],
      controllerAs: '$ctrl',
      ncyBreadcrumb: {
        skip: true,
      },
      onExit(spinnerTransitionDeregistration) {
        // Stop listening for transitions
        spinnerTransitionDeregistration();
      },
    })

    // Redirects to a different school "home" landing state depending on V3 toggle setting (CM).
    .state('main.school.home', {
      url: '/home',
      controller($state: IStateService) {
        $state.go('main.school.lists.my-students-list');
      },
    })

    /**
     * Routes to v3 features - JYR
     * TODO: Though these routes are children of routes to ng1 features, they lead to ng2
     * functionality. Does it make any sense to move them into their own routes file within the /ng2
     * directory, for clarity?
     */
    .state(`main.school.lists`, {
      abstract: true,
      views: {
        '': {
          template: require('../../../ng2/school/lists/school-lists.html'),
        },
        'schoolNav@main.school.lists': {
          template: `
            <nvps-side-nav
              [current-user]='$resolve.currentUser'
            ></nvps-side-nav>
          `,
        },
        'content@main.school.lists': {
          template: `
          <div ui-view></div>
          `,
        },
      },
      resolve: {
        madlibOptions$: [
          'MadLibResolver',
          'currentSchool',
          'Store',
          (MadLibResolver, currentSchool, Store) => MadLibResolver.resolveMadLibOptions$(currentSchool, Store),
        ],
        batchActionsMode$: [
          'Store',
          (Store: Store<any>) => {
            return new Promise(resolve => {
              resolve(Store.select(getBatchActionsMode));
            });
          },
        ],
      },
      data: {
        // TODO: what are the correct permissions? how does toggle fit into this?
        roles: USER_ROLE_PERMISSIONS_FOR_STATES['main.school.lists'],
      },
      onExit(Store: Store<any>) {
        resetStoredListState(Store);
      },
    })

    // DEPRECATED! TODO: REMOVE AFTER LIST REFACTOR IS COMPLETE.
    .state('main.school.lists.my-students-list', {
      url: '/lists/my-students-list/?Dimension1?Dimension2?SortedColumn?SortBy?Type?Search?List',
      controller($state: IStateService) {
        $state.go('main.school.lists.students');
      },
    })

    // REFACTORED STUDENTS_LIST
    .state('main.school.lists.students', {
      abstract: false,
      url: '/lists/students-list/?focus?filter?grouping?sortKey?sortDirection?search',
      template: `<students-list-v2
        [school-id]="$resolve.currentSchool._id"
        [batch-actions-mode$]="$resolve.batchActionsMode$"
      ></students-list-v2>`,
      onEnter: (Store: Store<any>) => {
        resetStoredListState(Store);
      },
    })

    // REFACTORED ATTENDANCE_LIST
    .state('main.school.lists.attendance', {
      abstract: false,
      url: '/lists/attendance-list/?focus?filter?grouping?sortKey?sortDirection?search',
      template: `<attendance-list-v2 
            [school-id]="$resolve.currentSchool._id"
            [batch-actions-mode$]="$resolve.batchActionsMode$"
          ></attendance-list-v2>`,
      onEnter: (Store: Store<any>) => {
        resetStoredListState(Store);
      },
    })

    // REFACTORED ACADEMIC_LIST
    .state('main.school.lists.academic', {
      abstract: false,
      url: '/lists/academic-list/?focus?filter?grouping?sortKey?sortDirection?search',
      template: `<academic-list-v2
        [school-id]="$resolve.currentSchool._id"
        [batch-actions-mode$]="$resolve.batchActionsMode$"
      ></academic-list-v2>`,
      onEnter: (Store: Store<any>) => {
        resetStoredListState(Store);
      },
    })
    // REFACTORED POSTSECONDARY_LIST
    .state('main.school.lists.postsecondary', {
      abstract: false,
      url: '/lists/postsecondary-list/?focus?filter?grouping?sortKey?sortDirection?search',
      template: `<postsecondary-list-v2 
        [school-id]="$resolve.currentSchool._id"
        [batch-actions-mode$]="$resolve.batchActionsMode$"
      ></postsecondary-list-v2>`,
      onEnter: (Store: Store<any>) => {
        resetStoredListState(Store);
      },
    })

    // Per requirements on https://newvisions.atlassian.net/browse/PFD-7450 , keep this code until further notice.

    // REGENTS EXEMPTIONS LIST
    // .state('main.school.lists.regents-exemptions', {
    //   abstract: false,
    //   url: '/lists/regents-exemptions/?focus?filter?grouping?sortKey?sortDirection?search',
    //   template: `<regents-exemptions-list
    //     [school-id]="$resolve.currentSchool._id"
    //     [batch-actions-mode$]="$resolve.batchActionsMode$"
    //   ></regents-exemptions-list >`,
    //   onEnter: (Store: Store<any>) => {
    //     resetStoredListState(Store);
    //   },
    // })

    // SUMMER SCHOOL LIST
    .state('main.school.lists.summer-school', {
      abstract: false,
      url: '/lists/summer-school/?focus?filter?grouping?sortKey?sortDirection?search',
      data: {
        roles: USER_ROLE_PERMISSIONS_FOR_STATES['main.school.lists.summer-school'],
      },
      template: `<summer-school-list 
      [school-id]="$resolve.currentSchool._id"
      [batch-actions-mode$]="$resolve.batchActionsMode$"
    ></summer-school-list >`,
      onEnter: (ImSchool: ImSchool, currentSchool: ISummerSchool, Store: Store<any>, $state: IStateService) => {
        const currentTermNumber = ImSchool.getCurrentTermNumber(currentSchool);
        if (currentTermNumber !== 7 || !ImSchool.isSummerSchool(currentSchool)) $state.go('main.home');
        resetStoredListState(Store);
      },
    })
    // Updated dashboards view
    .state(`main.school.lists.tiles`, {
      abstract: false,
      url: '/lists/tiles',
      template: `<tiles
        [current-school]="$resolve.currentSchool"
        [current-user]="$resolve.currentUser"
      ></tiles>`,
      onEnter: ($state: IStateService, ImUser: ImUser, currentUser: IUser) => {
        $state.transition.then(() => {
          const isCaseloadUser = ImUser.isCaseloadUser(currentUser);
          if (isCaseloadUser) $state.go('main.home');
        });
      },
    })
    // Updated mid-level dashboards view - change from dashboard tiles view to mid-level
    .state(`main.school.lists.midLevel`, {
      abstract: false,
      url: '/lists/mid-level/?focus?filter?grouping',
      reloadOnSearch: false,
      template: `
      <mid-level-dash
        [current-school]="$resolve.currentSchool"
      ></mid-level-dash>`,
      onEnter: (
        SpinnerModal: SpinnerModal,
        $state: IStateService,
        ImUser: ImUser,
        currentUser: IUser,
        ToggleService: ToggleService,
      ) => {
        $state.transition.then(() => {
          const toggle = getDashboardToggle($state.params.focus);
          if (toggle) {
            const isAllowed = ToggleService.getToggleState(toggle);
            if (!isAllowed) $state.go('main.school.lists.tiles');
          }
          // redirect to tiles if trying to access old dashboards (JE)
          const isDeprecatedGraph = DEPRECATED_GRAPHS[$state.params.focus];
          if (isDeprecatedGraph) $state.go('main.school.lists.tiles');
          const isCaseloadUser = ImUser.isCaseloadUser(currentUser);
          if (isCaseloadUser) $state.go('main.home');
        });
        SpinnerModal.deactivateSpinner();
      },
    })

    .state(`main.school.lists.studentLevel`, {
      abstract: false,
      url:
        '/lists/student-level/?focus?filter?grouping?studentFilter?studentGrouping?rowStub?sortKey?sortDirection?search',
      template: `
      <student-level-dash
        [schoolId]="$resolve.currentSchool._id"
        [focus-data$]="$resolve.focusData$"
        [grouping-data$]="$resolve.studentGroupingsData$"
        [columns]="$resolve.studentGroupingsColumns"
        [school-id]="$resolve.schoolId"
        [batch-actions-mode$]="$resolve.batchActionsMode$"
      ></student-level-dash>`,
      resolve: {
        schoolId: ['currentSchool', ({ _id: schoolId }) => schoolId],
      },
      onEnter: (
        SpinnerModal: SpinnerModal,
        $state: IStateService,
        ImUser: ImUser,
        currentUser: IUser,
        ToggleService: ToggleService,
      ) => {
        $state.transition.then(() => {
          const toggle = getDashboardToggle($state.params.focus);
          if (toggle) {
            const isAllowed = ToggleService.getToggleState(toggle);
            if (!isAllowed) $state.go('main.school.lists.tiles');
          }
          const isCaseloadUser = ImUser.isCaseloadUser(currentUser);
          if (isCaseloadUser) $state.go('main.home');
        });
        SpinnerModal.deactivateSpinner();
      },
    })

    // MID_LEVEL_MANAGER_VIEW
    .state('main.school.lists.graph-detail', {
      abstract: false,
      url: '/lists/dashboard/:graphName/?Dimension1?Groupings',
      resolve: {
        students$: [
          'StudentsResolver',
          'currentSchool',
          'Store',
          (StudentsResolver, currentSchool, Store) =>
            StudentsResolver.resolveAllStudentsList$(
              {
                studentLoadAction: LoadDashboardStudents,
                loadedStatusSelector: getDashboardStudentsLoadedStatus,
                studentSelector: getDashboardStudentsList,
              },
              currentSchool,
              Store,
            ),
        ],
        milestones$: [
          'currentSchool',
          'Store',
          'MilestoneResolver',
          (currentSchool, Store, MilestoneResolver) => MilestoneResolver.resolveMilestones$(currentSchool, Store),
        ],
        studentPaths$: [
          'currentSchool',
          'Store',
          'StudentPathsResolver',
          (currentSchool, Store, StudentPathsResolver) =>
            StudentPathsResolver.resolveStudentPaths$(currentSchool, Store),
        ],
        flags$: [
          'FlagsResolver',
          'currentSchool',
          'Store',
          (FlagsResolver, currentSchool, Store) => FlagsResolver.resolveFlags$(currentSchool, Store),
        ],
        studentSupports$: [
          'currentSchool',
          'Store',
          (currentSchool: ISchool, Store: Store<any>) => {
            const payload = { schoolId: currentSchool._id };
            const destroy$: Subject<boolean> = new Subject<boolean>();
            return new Promise(resolve => {
              Store.select(getLoadedDashboardStudentSupportsStatus)
                .pipe(takeUntil(destroy$))
                .subscribe((loaded: boolean) => {
                  if (!loaded) Store.dispatch(new LoadDashboardStudentSupports(payload));
                  if (loaded) {
                    const studentSupports$ = Store.select(getDashboardStudentSupports);
                    destroy$.next(true);
                    resolve(studentSupports$);
                  }
                });
            });
          },
        ],
        graphData: [
          '$stateParams',
          'Store',
          'students$',
          'studentSupports$',
          'DashboardGraphDataResolver',
          ($stateParams, Store, students$, studentSupports$, DashboardGraphDataResolver) =>
            DashboardGraphDataResolver.resolveSelectedDashboardGraphData(
              $stateParams,
              Store,
              students$,
              studentSupports$,
            ),
        ],
        madlibState: [
          'Store',
          'MadLibStoreStateResolver',
          (Store, MadLibStoreStateResolver) =>
            MadLibStoreStateResolver.resolveMadLibStoreState$(getDashboardMadLibState, Store),
        ],
      },
      template: `
        <graph-detail
          [madlib-state]="$resolve.madlibState"
          [madlib-options$]="$resolve.madlibOptions$"
          [flags$]="$resolve.flags$"
          [user]="$resolve.currentUser"
          [school]="$resolve.currentSchool"
          [students$]="$resolve.students$"
          [student-supports$]= "$resolve.studentSupports$"
          [milestones$]="$resolve.milestones$"
          [student-paths$]="$resolve.studentPaths$"
          [graph-data]="$resolve.graphData">
        </graph-detail>`,
      onEnter: (
        SpinnerModal: SpinnerModal,
        Store: Store<any>,
        $state: IStateService,
        ImUser: ImUser,
        currentUser: IUser,
        graphData: { isAdminOnly: boolean },
      ) => {
        $state.transition.then(() => {
          const { isAdminOnly } = graphData;
          const isAdmin = ImUser.isSchoolClusterOrDelegatedAdmin(currentUser);
          const isCaseloadUser = ImUser.isCaseloadUser(currentUser);
          if ((isAdminOnly && !isAdmin) || isCaseloadUser) $state.go('main.home');
          // redirect if trying to access deprecated url (JE)
          const isDeprecatedGraph = DEPRECATED_GRAPHS[$state.params.graphName];
          if (isDeprecatedGraph) $state.go('main.school.lists.tiles');
        });
        SpinnerModal.deactivateSpinner();
        resetStoredListState(Store);
      },
    })

    // STUDENT_LEVEL_MANAGER_VIEW
    .state('main.school.lists.graph-list', {
      abstract: false,
      /**
       * :navDataType -> the selected grouping from the mid-level
       * :navData -> the row the user clicked, triggering the state.go here
       */
      url: '/lists/dashboard/:graphName/:navDataType/:navData/?subject?studentIds',
      params: { subject: null },
      resolve: {
        students$: [
          'Store',
          '$stateParams',
          'ObjectCache',
          'currentSchool',
          (Store, $stateParams, ObjectCache, currentSchool) => {
            // no need to resolve data if trying to access deprecated url (JE)
            const isDeprecatedGraph = DEPRECATED_GRAPHS[$stateParams.graphName];
            if (isDeprecatedGraph) {
              return of([]);
            } else {
              const { studentIds } = $stateParams;
              const destroy$: Subject<boolean> = new Subject<boolean>();
              const dashStudentPayload = { schoolId: currentSchool._id };

              return new Promise(resolve => {
                ObjectCache.getObject(studentIds).then(({ studentIds }) => {
                  Store.select(getDashboardStudentsLoadedStatus)
                    .pipe(takeUntil(destroy$))
                    .subscribe(loaded => {
                      if (!loaded) Store.dispatch(new LoadDashboardStudents(dashStudentPayload));

                      if (loaded) {
                        const dashboardStudents$ = Store.select(getDashboardStudentsList);
                        const filteredAndSortedStudents$ = dashboardStudents$.pipe(
                          map((students: any[]) => {
                            return students
                              .filter(({ studentId }) => includes(studentIds, studentId))
                              .sort((a: any, b: any) => {
                                const studentNameA = a.studentDetails.name.last;
                                const studentNameB = b.studentDetails.name.last;
                                if (studentNameA < studentNameB) return -1;
                                if (studentNameA > studentNameB) return 1;
                                return 0;
                              });
                          }),
                        );

                        destroy$.next(true);
                        destroy$.unsubscribe();

                        resolve(filteredAndSortedStudents$);
                      }
                    });
                });
              });
            }
          },
        ],

        subject: [
          '$stateParams',
          $stateParams => {
            const { subject } = $stateParams;
            return new Promise(resolve => {
              resolve(subject);
            });
          },
        ],

        studentSupports$: [
          'currentSchool',
          'Store',
          (currentSchool: ISchool, Store: Store<any>) => {
            const payload = { schoolId: currentSchool._id };
            const destroy$: Subject<boolean> = new Subject<boolean>();
            return new Promise(resolve => {
              Store.select(getLoadedDashboardStudentSupportsStatus)
                .pipe(takeUntil(destroy$))
                .subscribe((loaded: boolean) => {
                  if (!loaded) Store.dispatch(new LoadDashboardStudentSupports(payload));
                  if (loaded) {
                    const studentSupports$ = Store.select(getDashboardStudentSupports);
                    destroy$.next(true);
                    resolve(studentSupports$);
                  }
                });
            });
          },
        ],
        graphData: [
          '$stateParams',
          'Store',
          'students$',
          'studentSupports$',
          'DashboardGraphDataResolver',
          ($stateParams, Store, students$, studentSupports$, DashboardGraphDataResolver) =>
            DashboardGraphDataResolver.resolveSelectedDashboardGraphData(
              $stateParams,
              Store,
              students$,
              studentSupports$,
            ),
        ],
        milestones$: [
          'currentSchool',
          'Store',
          'MilestoneResolver',
          (currentSchool, Store, MilestoneResolver) => MilestoneResolver.resolveMilestones$(currentSchool, Store),
        ],
        studentPaths$: [
          'currentSchool',
          'Store',
          'StudentPathsResolver',
          (currentSchool, Store, StudentPathsResolver) =>
            StudentPathsResolver.resolveStudentPaths$(currentSchool, Store),
        ],
        flags$: [
          'FlagsResolver',
          'currentSchool',
          'Store',
          (FlagsResolver, currentSchool, Store) => FlagsResolver.resolveFlags$(currentSchool, Store),
        ],
      },
      template: `
        <graph-list
          [course]="$resolve.course"
          [subject]="$resolve.subject"
          [graph-title]="$resolve.graphData.title"
          [graph-type]="$resolve.graphData.type"
          [graph-group]="$resolve.graphData.group"
          [students$]="$resolve.students$"
          [student-supports$]="$resolve.studentSupports$"
          [flags$]="$resolve.flags$"
          [school]="$resolve.currentSchool"
          [milestones$]="$resolve.milestones$"
          [student-paths$]="$resolve.studentPaths$"
        >
        </graph-list>`,
      onEnter: (
        SpinnerModal: SpinnerModal,
        Store: Store<any>,
        $state: IStateService,
        ImUser: ImUser,
        currentUser: IUser,
        graphData: { isAdminOnly: boolean },
      ) => {
        $state.transition.then(() => {
          const { isAdminOnly } = graphData;
          const isAdmin = ImUser.isSchoolClusterOrDelegatedAdmin(currentUser);
          const isCaseloadUser = ImUser.isCaseloadUser(currentUser);
          if ((isAdminOnly && !isAdmin) || isCaseloadUser) $state.go('main.home');
          // redirect if trying to access deprecated url (JE)
          const isDeprecatedGraph = DEPRECATED_GRAPHS[$state.params.graphName];
          if (isDeprecatedGraph) $state.go('main.school.lists.tiles');
        });
        SpinnerModal.deactivateSpinner();
        resetStoredListState(Store);
      },
    })

    // OTHER TOOLS

    .state(`main.school.other-tools`, {
      url: '/other-tools',
      abstract: true,
      views: {
        '': {
          template: require('../../../ng2/school/school-tools/other-tools/other-tools-shell.html'),
        },
        'schoolNav@main.school.other-tools': {
          template: `
        <other-tools-left-nav
          [tools$]='$resolve.tools$'
          [show-synced-sheets]='$resolve.showSyncedSheets'
          [current-user]='$resolve.currentUser'
          [current-school]='$resolve.currentSchool'
        ></other-tools-left-nav>
        `,
        },
        'content@main.school.other-tools': {
          template: `
        <div ui-view></div>
        `,
        },
      },
      resolve: {
        courseDiffs: [
          'CourseDiff',
          'currentSchool',
          (CourseDiff, currentSchool) => {
            let promise = CourseDiff.query({ schoolId: currentSchool._id }).$promise;

            return promise.then(courseDiffs => {
              return courseDiffs;
            });
          },
        ],
        students$: [
          'StudentsResolver',
          'currentSchool',
          'Store',
          (StudentsResolver, currentSchool, Store) =>
            StudentsResolver.resolveAllStudentsList$(
              {
                studentLoadAction: LoadMyStudents,
                loadedStatusSelector: getMyStudentsLoadedStatus,
                studentSelector: getMyStudentsList,
              },
              currentSchool,
              Store,
            ),
        ],
        tools$: [
          'ToolsResolver',
          'currentSchool',
          'Store',
          (ToolsResolver, currentSchool, Store) => ToolsResolver.resolveAllTools$(currentSchool, Store),
        ],
        showSyncedSheets: [
          'ImUser',
          'currentUser',
          (ImUser: ImUser, currentUser: IUser) => {
            const roleCanAccessSync = ImUser.canAccessSync(currentUser);
            const hasGafeEmail = !!ImUser.getGafeEmail(currentUser);
            const gafeEmailDomain = ImUser.getGafeEmailDomain(currentUser);
            const domainIsSyncEnabled = includes(SYNC_ENABLED_DOMAINS, gafeEmailDomain);
            return roleCanAccessSync && hasGafeEmail && domainIsSyncEnabled;
          },
        ],
      },
      onEnter: (
        SpinnerModal: SpinnerModal,
        tools$,
        showSyncedSheets,
        $state: IStateService,
        $stateParams,
        ImSchool: ImSchool,
        currentSchool: ISchool,
        currentUser: IUser,
        ImUser: ImUser,
      ) => {
        const destroy$: Subject<boolean> = new Subject<boolean>();
        const isHS = ImSchool.isHighSchool(currentSchool);
        tools$.pipe(takeUntil(destroy$)).subscribe(tools => {
          let groupedTools = groupBy(tools, (tool: ITool) => {
            return tool.metaData.sheetToolType;
          });
          let currentSelection: string = 'currentSelection';
          const filterArr = filter(GOOGLE_SHEETS_OPTIONS, option => {
            const key = SHEET_TYPE_HUMAN_MAP[option];
            return !!groupedTools[key];
          });
          destroy$.next(true);
          destroy$.unsubscribe();
          const showOtherSheetOpts = filterArr.length;
          $state.transition.then(() => {
            if (showSyncedSheets) {
              $state.go('main.school.other-tools.synced-sheets', null, { location: 'replace' });
            } else if (showOtherSheetOpts) {
              const routeName = SHEET_TYPE_TO_ROUTE[filterArr[0]];
              $stateParams[currentSelection] = routeName;
              $state.go('main.school.other-tools.default', { currentSelection: routeName }, { location: 'replace' });
            } else {
              if (isHS && !ImUser.isViewType(currentUser))
                $state.go('main.school.other-tools.next-term-planning', null, { location: 'replace' });
              else $state.go('main.school.other-tools.resources', null, { location: 'replace' });
            }
          });
          SpinnerModal.deactivateSpinner();
        });
      },
    })

    .state(`main.school.other-tools.program-changes-and-gap-plans`, {
      url: '/program-changes-and-gap-plans',
      abstract: false,
      template: `
      <course-diffs-and-gap-plans-table
        current-school="$resolve.currentSchool"
        gap-plans="$resolve.gapPlans"
        course-diffs="$resolve.courseDiffs"
      ></course-diffs-and-gap-plans-table>
    `,
      resolve: {
        gapPlans: [
          'GapPlan',
          'currentSchool',
          (GapPlan, currentSchool) => {
            const projection = {
              _id: true,
              studentId: true,
              student: true,
              createdAt: true,
              createdBy: true,
              courseOrplan: true,
              creditValue: true,
              gradReq: true,
              plan: true,
              termYear: true,
              status: true,
              note: true,
              show: true,
            };
            let promise = GapPlan.query({ schoolId: currentSchool._id, projection }).$promise;
            return promise.then(gapPlans => {
              return gapPlans;
            });
          },
        ],
      },
      data: {
        roles: USER_ROLE_PERMISSIONS_FOR_STATES['main.school.other-tools'],
      },
      onEnter: (SpinnerModal: SpinnerModal) => {
        SpinnerModal.deactivateSpinner();
      },
    })

    .state(`main.school.other-tools.next-term-planning`, {
      url: '/next-term-planning',
      abstract: false,
      params: {
        currentSelection: 'next-term-planning',
      },
      template: `
      <next-term-planning
        current-school="$resolve.currentSchool"
        gap-plans="$resolve.gapPlans"
        course-diffs="$resolve.courseDiffs"
      ></next-term-planning>
    `,
      resolve: {
        gapPlans: [
          'GapPlan',
          'currentSchool',
          (GapPlan, currentSchool) => {
            const projection = {
              _id: true,
              studentId: true,
              student: true,
              createdAt: true,
              createdBy: true,
              courseOrplan: true,
              creditValue: true,
              gradReq: true,
              plan: true,
              termYear: true,
              status: true,
              note: true,
              show: true,
            };
            let promise = GapPlan.query({ schoolId: currentSchool._id, projection }).$promise;
            return promise.then(gapPlans => {
              return gapPlans;
            });
          },
        ],
      },
      data: {
        roles: USER_ROLE_PERMISSIONS_FOR_STATES['main.school.other-tools.next-term-planning'],
      },
      onEnter: (SpinnerModal: SpinnerModal) => {
        SpinnerModal.deactivateSpinner();
      },
    })

    .state(`main.school.other-tools.resources`, {
      url: '/resources',
      abstract: false,
      template: `
      <other-tools-resources
        current-school="$resolve.currentSchool"
        gap-plans="$resolve.gapPlans"
        course-diffs="$resolve.courseDiffs"
      ></other-tools-resources>
    `,
      resolve: {
        gapPlans: [
          'GapPlan',
          'currentSchool',
          (GapPlan, currentSchool) => {
            const projection = {
              _id: true,
              studentId: true,
              student: true,
              createdAt: true,
              createdBy: true,
              courseOrplan: true,
              creditValue: true,
              gradReq: true,
              plan: true,
              termYear: true,
              status: true,
              note: true,
              show: true,
            };
            let promise = GapPlan.query({ schoolId: currentSchool._id, projection }).$promise;
            return promise.then(gapPlans => {
              return gapPlans;
            });
          },
        ],
      },
      onEnter: (SpinnerModal: SpinnerModal) => {
        SpinnerModal.deactivateSpinner();
      },
    })

    .state(`main.school.other-tools.synced-sheets`, {
      url: '/synced-sheets',
      abstract: false,
      params: {
        currentSelection: 'synced-sheets',
      },
      template: `
      <other-tools
        [current-user]='$resolve.currentUser'
        [students$]="$resolve.students$"
        [tools$]="$resolve.tools$"
        [current-school]="$resolve.currentSchool"
        [school-assessments$]="$resolve.schoolAssessments$"
      ></other-tools>
    `,
      resolve: {
        courseDiffs: [
          'CourseDiff',
          'currentSchool',
          (CourseDiff, currentSchool) => {
            let promise = CourseDiff.query({ schoolId: currentSchool._id }).$promise;

            return promise.then(courseDiffs => {
              return courseDiffs;
            });
          },
        ],
        students$: [
          'StudentsResolver',
          'currentSchool',
          'Store',
          (StudentsResolver, currentSchool, Store) =>
            StudentsResolver.resolveAllStudentsList$(
              {
                studentLoadAction: LoadMyStudents,
                loadedStatusSelector: getMyStudentsLoadedStatus,
                studentSelector: getMyStudentsList,
              },
              currentSchool,
              Store,
            ),
        ],
        schoolAssessments$: [
          'Store',
          'currentSchool',
          (Store, currentSchool) => {
            const { _id } = currentSchool;
            const payload = { schoolId: _id, schoolYear: CurrentSchoolYear.WITH_SY_PREFIX };
            const schoolAssessmentsLoaded = getSchoolAssessmentsLoadedStatus;
            const destroy$: Subject<boolean> = new Subject<boolean>();
            return new Promise(resolve => {
              Store.select(schoolAssessmentsLoaded)
                .pipe(takeUntil(destroy$))
                .subscribe(loaded => {
                  if (!loaded) {
                    Store.dispatch(new LoadSchoolAssessments(payload));
                  } else {
                    const schoolAssessments = getSchoolAssessmentsEntitiesList;
                    const schoolAssessments$ = Store.select(schoolAssessments);
                    destroy$.next(true);
                    destroy$.unsubscribe();
                    resolve(schoolAssessments$);
                  }
                });
            });
          },
        ],
      },
      data: {
        roles: USER_ROLE_PERMISSIONS_FOR_STATES['main.school.other-tools.synced-sheets'],
      },
      onEnter: (SpinnerModal: SpinnerModal) => {
        SpinnerModal.deactivateSpinner();
      },
    })

    .state(`main.school.other-tools.default`, {
      abstract: false,
      params: { currentSelection: null },
      url: '/:currentSelection',
      template: `
      <other-tools
        [current-user]='$resolve.currentUser'
        [students$]="$resolve.students$"
        [tools$]="$resolve.tools$"
        [current-school]="$resolve.currentSchool"
      ></other-tools>
      `,
      resolve: {
        //
      },
    });
});
